// frontend/src/components/PointBadge.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { FaCoins } from 'react-icons/fa';

const PointBadge: React.FC = () => {
  const [balance, setBalance] = useState<number | null>(null);
  const [memberType, setMemberType] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/points/my')
      .then(res => { setBalance(res.data.balance); setMemberType(res.data.member_type ?? null); })
      .catch(() => {});
  }, []);

  // 法人所属(社員/家族/友人)のみ表示。残高0でも所属者には出す(=ポイント画面から社員認証や交換ができる)。
  // 未所属の一般患者には表示しない。
  if (!memberType) return null;

  return (
    <button
      onClick={() => navigate('/mypage/points')}
      className="flex items-center gap-1 bg-yellow-50 border border-yellow-200 text-yellow-700 rounded-full px-3 py-1 text-xs font-semibold hover:bg-yellow-100 transition-colors"
      title="ポイント残高"
    >
      <FaCoins className="text-yellow-500" />
      {(balance ?? 0).toLocaleString()} pt
    </button>
  );
};

export default PointBadge;
